<div class="p-6 bg-white rounded-2xl shadow-xl max-w-lg w-full">
  <!-- Dialog Header -->
  <div class="flex items-center justify-between border-b border-gray-100 pb-4 mb-4">
    <div class="flex items-center gap-3">
      <div class="w-10 h-10 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center text-lg">
        <i class="fas fa-lock"></i>
      </div>
      <div>
        <h3 class="text-lg font-bold text-gray-900">Change Password</h3>
        <p class="text-xs text-gray-500 mt-0.5">Enter your current password and your new password.</p>
      </div>
    </div>
    <button
      type="button"
      (click)="closeDialog()"
      class="text-gray-400 hover:text-gray-600 p-1.5 rounded-lg hover:bg-gray-100 transition-colors focus:outline-none"
    >
      <i class="fas fa-times text-base"></i>
    </button>
  </div>

  <!-- Dialog Form -->
  <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <!-- Current Password -->
    <div class="mb-4">
      <label for="current-password" class="block uppercase text-gray-600 text-xs font-bold mb-2">
        Current Password <span class="text-red-500">*</span>
      </label>
      <div class="relative">
        <input
          id="current-password"
          name="current-password"
          autocomplete="off"
          [readonly]="isCurrentPasswordReadOnly"
          (focus)="onCurrentPasswordFocus()"
          (click)="onCurrentPasswordFocus()"
          [type]="showCurrentPassword ? 'text' : 'password'"
          formControlName="currentPassword"
          placeholder="Enter current password"
          class="border border-gray-200 px-3.5 py-2.5 text-gray-800 bg-white rounded-xl text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 w-full pr-10 transition-all"
        />
        <button
          type="button"
          (click)="toggleShowCurrentPassword()"
          class="absolute right-3 top-3 text-gray-400 hover:text-gray-600 text-sm focus:outline-none"
        >
          <i [class]="showCurrentPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>
      @if (changePasswordForm.get('currentPassword')?.touched && changePasswordForm.get('currentPassword')?.hasError('required')) {
        <span class="text-xs text-red-500 font-semibold mt-1 block">Current password is required.</span>
      }
    </div>

    <!-- New Password -->
    <div class="mb-4">
      <label for="new-password" class="block uppercase text-gray-600 text-xs font-bold mb-2">
        New Password <span class="text-red-500">*</span>
      </label>
      <div class="relative">
        <input
          id="new-password"
          name="new-password"
          autocomplete="new-password"
          [type]="showNewPassword ? 'text' : 'password'"
          formControlName="newPassword"
          placeholder="Enter new password (min. 6 characters)"
          class="border border-gray-200 px-3.5 py-2.5 text-gray-800 bg-white rounded-xl text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 w-full pr-10 transition-all"
        />
        <button
          type="button"
          (click)="toggleShowNewPassword()"
          class="absolute right-3 top-3 text-gray-400 hover:text-gray-600 text-sm focus:outline-none"
        >
          <i [class]="showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>
      @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.hasError('required')) {
        <span class="text-xs text-red-500 font-semibold mt-1 block">New password is required.</span>
      }
      @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.hasError('minlength')) {
        <span class="text-xs text-red-500 font-semibold mt-1 block">New password must be at least 6 characters.</span>
      }
    </div>

    <!-- Confirm New Password -->
    <div class="mb-6">
      <label for="confirm-password" class="block uppercase text-gray-600 text-xs font-bold mb-2">
        Confirm New Password <span class="text-red-500">*</span>
      </label>
      <div class="relative">
        <input
          id="confirm-password"
          name="confirm-password"
          autocomplete="new-password"
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirmPassword"
          placeholder="Re-enter new password"
          class="border border-gray-200 px-3.5 py-2.5 text-gray-800 bg-white rounded-xl text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 w-full pr-10 transition-all"
        />
        <button
          type="button"
          (click)="toggleShowConfirmPassword()"
          class="absolute right-3 top-3 text-gray-400 hover:text-gray-600 text-sm focus:outline-none"
        >
          <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
        </button>
      </div>
      @if (changePasswordForm.get('confirmPassword')?.touched && changePasswordForm.get('confirmPassword')?.hasError('required')) {
        <span class="text-xs text-red-500 font-semibold mt-1 block">Please confirm your new password.</span>
      }
      @if (changePasswordForm.touched && changePasswordForm.hasError('passwordMismatch')) {
        <span class="text-xs text-red-500 font-semibold mt-1 block">New password and confirmation do not match.</span>
      }
    </div>

    <!-- Dialog Actions -->
    <div class="flex items-center justify-end gap-3 pt-3 border-t border-gray-100">
      <button
        type="button"
        (click)="closeDialog()"
        class="px-4 py-2 text-sm font-semibold text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-xl transition-colors cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="submit"
        [disabled]="isSubmitting"
        class="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-bold text-xs uppercase rounded-xl shadow-sm hover:shadow transition-all flex items-center gap-2 cursor-pointer disabled:opacity-50"
      >
        @if (isSubmitting) {
          <i class="fa fa-spinner fa-spin"></i> Updating...
        } @else {
          <i class="fas fa-check"></i> Update Password
        }
      </button>
    </div>
  </form>
</div>
